<template>
  <v-dialog v-model="active" persistent max-width="290">
    <v-card>
      <v-card-title class="text-h5"> Excluir foto </v-card-title>
      <v-card-text> Tem certeza que deseja excluir esta foto? Esta ação não poderá ser desfeita. </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text @click="close"> Cancelar </v-btn>
        <v-btn color="red darken-1" text @click="save"> Excluir </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  emits: ['close', 'save'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      active: false
    };
  },
  watch: {
    isActive(newValue) {
      this.active = newValue;
    },
    active(newValue) {
      if (!newValue) {
        this.close();
      }
    }
  },
  methods: {
    save() {
      this.$emit('save');
    },
    close() {
      this.$emit('close');
    }
  }
};
</script>
